import moment from 'moment';
import React from 'react';
import styles from './styles.css';

const Footer = () => (
  <div className={styles.footer}>
    <strong>
      &copy;&nbsp;
      <span id="year">{moment().year()}</span>
    </strong>
    {' Powered by '}
    <a href="http://gasbuddy.com/business" rel="noopener noreferrer" target="_blank">GasBuddy</a>
    . All rights reserved.
  </div>
);

export default Footer;
